import { useTranslation } from 'react-i18next'

import { EMPTY_FUNCTION } from '../../../../constants/common'
import { AIButtonTextGrey } from '../../../AIButton'
import Text from '../../../Text'
import { QA_NAME_GRETA_AI_CHAT_MORE_CHATS_RETRY } from '../GretaAIChatChatList.constants'

import * as styles from './GretaAIChatChatListMoreChats.module.css'

function GretaAIChatChatListMoreChats({
  hasFailed = false,
  onRetry = EMPTY_FUNCTION,
}) {
  const { t } = useTranslation()

  return (
    <div className={styles.moreChats}>
      {hasFailed ? (
        <>
          <Text isSecondary className={styles.moreChatsText}>
            {t('Greta.MoreChatsErrorKey')}
          </Text>
          <AIButtonTextGrey
            qaName={QA_NAME_GRETA_AI_CHAT_MORE_CHATS_RETRY}
            text={t('Greta.RetryButtonKey')}
            onClick={onRetry}
          />
        </>
      ) : (
        <Text isSecondary className={styles.moreChatsText}>
          {t('Greta.ChatListLoadingKey')}
        </Text>
      )}
    </div>
  )
}

export default GretaAIChatChatListMoreChats
